import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
import { ListingFormValues } from "@/components/listings/filters/FilterSchema";
import { furnishingOptions } from "@/lib/data/propertyTypes";

interface PlotDetailsSectionProps {
  form: UseFormReturn<ListingFormValues>;
}

const PlotDetailsSection = ({ form }: PlotDetailsSectionProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <FormField
        control={form.control}
        name="plotSizeSqft"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Land Size (Perch)</FormLabel>
            <FormControl>
              <Input
                type="number"
                placeholder="e.g., 5000"
                {...field}
                value={field.value ?? ""}
                onChange={(e) =>
                  field.onChange(parseFloat(e.target.value) || undefined)
                }
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="floorSizeSqFt"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Floor Size (sq ft)</FormLabel>
            <FormControl>
              <Input
                type="number"
                placeholder="e.g., 3000"
                {...field}
                value={field.value ?? ""}
                onChange={(e) =>
                  field.onChange(parseFloat(e.target.value) || undefined)
                }
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="furnishing"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Furnishing</FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select furnishing type" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {furnishingOptions.map((option) => (
                  <SelectItem key={option} value={option}>
                    {option}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default PlotDetailsSection;
